import { MarketplaceCategory } from '@/graphql';

const orderedCategories = (categories: MarketplaceCategory[]) => categories.slice().sort((a, b) => (a.name.toLowerCase() === 'other' ? 1 : a.name.localeCompare(b.name)));

export { orderedCategories };
